import {combineReducers} from 'redux';
import global from './global/reducer.js';

const reducers = () => {
  const appReducers: Reducers = {
    global,
  };

  return combineReducers(appReducers);
};

type Reducers = {
  global: typeof global;
};

export default reducers;
